import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SearchPage } from "@/features/helpdesk/search-page";
import { type SearchPageSearch, searchPageSchema } from "@/features/helpdesk/search-params";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/helpdesk/szukaj")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.helpdesk.szukaj", location.pathname);
	},
	validateSearch: (search: Record<string, unknown>): SearchPageSearch =>
		searchPageSchema.parse(search),
	component: SearchRoute,
});

function SearchRoute() {
	const search = Route.useSearch();
	const navigate = useNavigate({ from: "/helpdesk/szukaj" });
	return (
		<SearchPage
			search={search}
			onSearchChange={(patch) =>
				navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })
			}
		/>
	);
}
